module.exports = __webpack_public_path__ + "img/frankenstein.e95a3c4d.jpg";